var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRemoteSelect',_vm._g(_vm._b({attrs:{"item-value":"id","item-text":(c) => (`${c.spu_name}`),"find_api":_vm.$util.api.cya_spu_detail,"search_api":_vm.$util.api.cya_spu_select_search_operating,"item-default":{id: 0, uid: '', spu_name: ''}}},'VRemoteSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }